import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DevExtremeModule } from 'devextreme-angular';
import { IboxtoolsModule } from '../common/iboxtools/iboxtools.module';
import { baseZIndex } from 'devextreme/ui/overlay';
import { Options as dxDataGridOptions, default as dxDataGrid } from 'devextreme/ui/data_grid';
import { Options as dxTreeListOptions, default as dxTreeList } from 'devextreme/ui/tree_list';
import { Options as dxFormOptions, default as dxForm } from 'devextreme/ui/form';
import { Options as dxSelectBoxOptions, default as dxSelectBox } from 'devextreme/ui/select_box';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HrefDirective } from './href.directive';
import { Options as dxTextBoxOptions, default as dxTextBox } from 'devextreme/ui/text_box';
import { Options as dxTextAreaOptions, default as dxTextArea } from 'devextreme/ui/text_area';
import { Options as dxNumberBoxOptions, default as dxNumberBox } from 'devextreme/ui/number_box';
import { Options as dxDateBoxOptions, default as dxDateBox } from 'devextreme/ui/date_box';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import 'froala-editor/js/plugins.pkgd.min.js';
import { BaseDetailComponent } from './base-detail/base-detail.component';
import { InputDialogComponent } from './input-dialog/input-dialog.component';
import { AppInformationService } from '../core/app-information.service';
import saveAs from 'file-saver';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { EmailDialogComponent } from './email-dialog/email-dialog.component';

export { BaseDetailComponent };

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ModalModule.forRoot(),
        DevExtremeModule,
        IboxtoolsModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        HrefDirective,
        BaseDetailComponent,
        InputDialogComponent,
        EmailDialogComponent,
    ],
    exports: [DevExtremeModule, ModalModule, IboxtoolsModule, HrefDirective, FroalaEditorModule, FroalaViewModule, BaseDetailComponent],
})
export class SharedModule {
    public static onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    constructor(public appInfo: AppInformationService) {
        const dataGridOptions: dxDataGridOptions = {
            // height: '100%',
            height: '100px' /* hack default value to make scrolling work */,
            // width: '100px',
            width: '100%',
            columnAutoWidth: true,
            columnResizingMode: 'widget',
            allowColumnReordering: true,
            allowColumnResizing: true,
            hoverStateEnabled: true,
            showBorders: true,
            showColumnLines: false,
            showRowLines: true,
            rowAlternationEnabled: false,
            sorting: { mode: 'multiple' },
            paging: { enabled: false, pageSize: 50 },
            scrolling: {
                mode: 'virtual',
                showScrollbar: 'always',
                preloadEnabled: true,
                useNative: true,
            },
            // searchPanel: { placeholder: 'Search...'},
            selection: { mode: 'none', showCheckBoxesMode: 'onLongTap' },
            stateStoring: { savingTimeout: 800 },
            filterRow: { applyFilter: 'auto' },
            focusedRowEnabled: true,
            onExporting: SharedModule.onExporting,
            onToolbarPreparing: (e) => {
                if (!e.component.option('stateStoring.enabled')) return;
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        icon: this.appInfo.graafschap ? 'refresh' : 'revert',
                        elementAttr: { title: 'Reset Grid Layout' },
                        onClick: () => {
                            e.component.state({});
                        },
                    },
                });
                if (e.component.option('filterRow.visible') && this.appInfo.graafschap) {
                    e.toolbarOptions.items.unshift({
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            icon: 'revert',
                            elementAttr: { title: 'Reset Filters' },
                            onClick: () => {
                                e.component.clearFilter();
                            },
                        },
                    });
                }
            },
        };
        dxDataGrid.defaultOptions({ options: dataGridOptions });

        const treeListOptions: dxTreeListOptions = {
            // height: '100px',
            width: '100%',
            allowColumnResizing: true,
            columnResizingMode: 'widget',
            showBorders: true,
            hoverStateEnabled: false,
            selection: { mode: 'single' },
            stateStoring: { savingTimeout: 800 },
        };
        dxTreeList.defaultOptions({ options: treeListOptions });

        const formOptions: dxFormOptions = {
            showColonAfterLabel: false,
            labelLocation: 'left',
            // labelLocation: 'top'
        };
        dxForm.defaultOptions({ options: formOptions });

        const selectboxOptions: dxSelectBoxOptions = {
            searchEnabled: true,
            searchTimeout: 100,
            showClearButton: true,
            inputAttr: { autocomplete: 'dx-select-input' },
        };
        dxSelectBox.defaultOptions({ options: selectboxOptions });

        const textboxOptions: dxTextBoxOptions = {
            // valueChangeEvent: 'keyup changed blur'
            valueChangeEvent: 'input',
        };
        dxTextBox.defaultOptions({ options: textboxOptions });

        const textareaOptions: dxTextAreaOptions = {
            valueChangeEvent: 'input',
        };
        dxTextArea.defaultOptions({ options: textareaOptions });

        const numberboxOptions: dxNumberBoxOptions = {
            showSpinButtons: false,
            valueChangeEvent: 'input',
        };
        dxNumberBox.defaultOptions({ options: numberboxOptions });

        const dateboxOptions: dxDateBoxOptions = {
            // valueChangeEvent: 'input',
        };
        dxDateBox.defaultOptions({ options: dateboxOptions });

        baseZIndex(3000);
    }

    public static async onExporting(e, fileName: string = 'export', worksheetName: string = 'Data') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(worksheetName);
        await exportDataGrid({ component: e.component, worksheet: worksheet });
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
    }
}
